export default "__VITE_ASSET__4faefa2e__"